module.exports = __webpack_public_path__ + "static/media/warning.cec278a6.svg";